import type {PlacemarkType} from '../types'

export function getPlacemarkType(index: number, destinationsCount: number): PlacemarkType {
  if (index === 0) {
    return 'source'
  }

  if (destinationsCount < 2) {
    return 'destination'
  }

  return 'numeric'
}
